// extracted by mini-css-extract-plugin
export default {"container":"ModalPublicacion_container__KbLAi","subT":"ModalPublicacion_subT__9Ihrf"};